import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import TopHeader from '../template/TopHeader';
import MobileSubmenu from '../shared/MobileSubmenu';
import { connect } from "react-redux";

class FinanceMobileNav extends Component {

    handleNavClick = (url) => {
        this.props.history.push(url);
    };

    render() {
        const navItems = [
            {
                id: 'overview',
                title: 'Overview',
                description: 'Revenue and performance summary',
                url: '/finance?tab=overview',
                icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="20" x2="18" y2="10" /><line x1="12" y1="20" x2="12" y2="4" /><line x1="6" y1="20" x2="6" y2="14" /><line x1="2" y1="20" x2="22" y2="20" /></svg>
            },
            {
                id: 'transactions',
                title: 'Transactions',
                description: 'View all payment transactions',
                url: '/finance?tab=transactions',
                icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="8" y1="6" x2="21" y2="6" /><line x1="8" y1="12" x2="21" y2="12" /><line x1="8" y1="18" x2="21" y2="18" /><line x1="3" y1="6" x2="3.01" y2="6" /><line x1="3" y1="12" x2="3.01" y2="12" /><line x1="3" y1="18" x2="3.01" y2="18" /></svg>
            },
            {
                id: 'commissions',
                title: 'Commissions',
                description: 'Track and collect staff commissions',
                url: '/finance?tab=commissions',
                icon: (
                    <svg viewBox="0 0 24 24">
                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.41 16.09V20h-2.67v-1.93c-1.71-.36-3.16-1.46-3.27-3.4h1.96c.1 1.05.82 1.87 2.65 1.87 1.96 0 2.4-.98 2.4-1.59 0-.83-.44-1.61-2.67-2.14-2.48-.6-4.18-1.62-4.18-3.67 0-1.72 1.39-2.84 3.11-3.21V4h2.67v1.95c1.86.45 2.79 1.86 2.85 3.39H14.3c-.05-1.11-.64-1.87-2.22-1.87-1.5 0-2.4.68-2.4 1.64 0 .84.65 1.39 2.67 1.94s4.18 1.36 4.18 3.85c0 1.89-1.44 2.93-3.12 3.19z"/>
                    </svg>
                )
            },
            {
                id: 'reports',
                title: 'Reports',
                description: 'Detailed financial reports',
                url: '/finance?tab=reports',
                icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><polyline points="14 2 14 8 20 8" /><line x1="16" y1="13" x2="8" y2="13" /><line x1="16" y1="17" x2="8" y2="17" /></svg>
            },
            {
                id: 'cashup',
                title: 'Cash Up',
                description: 'Daily cash up reconciliation',
                url: '/finance?tab=cashup',
                icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="1" x2="12" y2="23" /><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" /></svg>
            },
        ];

        return (
            <div className="h_n">
                <div className="body_container cm_bg_white">
                    <TopHeader title="Finance" headerButtonStatus={true} {...this.props} />
                    <MobileSubmenu items={navItems} onNavigate={this.handleNavClick} />
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return { ...state };
}

export default withRouter(connect(mapStateToProps)(FinanceMobileNav));
